import { render } from "./DataTable.vue?vue&type=template&id=6fa2b8c6&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=6fa2b8c6&scoped=true&lang=css"
import "./DataTable.vue?vue&type=style&index=1&id=6fa2b8c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa2b8c6"]])

export default __exports__